import { connect } from 'react-redux';
import { goBack, push } from 'connected-react-router';
import AreYouSurePage from '@rental-manager/pages/Onboarding/RentalProtectionAreYouSurePage/component';
import { closeNotification, showModalNotification } from '@common/actions/NotificationActions';
import paths from '@rental-manager/pathsManifest';
import { DEFAULT_ERROR } from '@rental-manager/constants/NotificationConstants';
import { resetNewTermSettings, saveNewTermSettings } from '@rental-manager/actions/DashboardActions';
import { pageFlows } from '../../pageFlows';
import { toggleFeature } from '@rental-manager/actions/requests';
import { checkRequestActionSuccess } from '@common/paymentsUtils/api';
import { saveLeaseId, saveRentalProtectionFeature } from '@rental-manager/actions/OnboardingActions';
import { logError } from '@zg-rentals/log-error';

const mapStateToProps = (state, { propertyId, location }: Record<string, any>) => {
  const fromLeaseSelectorPage = location?.state?.fromWhere === paths.onboarding.leaseSelectorPage;
  const { rentalProtectionDisclaimers } = state.payments.landlord.onboarding[propertyId];
  const { listingAlias } = state.payments.landlord.property;
  return {
    propertyId,
    listingAlias,
    fromLeaseSelectorPage,
    rentalProtectionDisclaimers,
  };
};

const mapDispatchToProps = (dispatch, { propertyId, baseUrl }) => ({
  addPaymentManually: ({ featureName, on }) =>
    Promise.resolve()
      .then(() => dispatch(toggleFeature({ propertyId, featureName, on })))
      .then(checkRequestActionSuccess)
      .then(() => dispatch(saveLeaseId({ propertyId, leaseId: null })))
      .then(() => dispatch(saveRentalProtectionFeature({ propertyId, rentGuarantee: false })))
      .then(() => dispatch(saveNewTermSettings({ currentPage: pageFlows.CurrentTenantEndDate })))
      .then(() => dispatch(push(baseUrl + paths.dashboard.setupNewTermPage)))
      .catch((err) => {
        logError({ error: err });
        dispatch(showModalNotification(DEFAULT_ERROR));
        return { error: true };
      }),
  onBack: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(goBack())),
  onClose: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(resetNewTermSettings()))
      .then(() => dispatch(push(baseUrl))),
});

export default connect(mapStateToProps, mapDispatchToProps)(AreYouSurePage);
